import axios from "axios";
import Vue from "vue";

const api = axios.create({
  baseURL: process.env.NODE_ENV === "production"
      ? "https://api.cuntubang.com"
      : "https://api.cuntubang.com",
  timeout: 300000
});

//本站API,用以设置api,key
Vue.prototype.$api = api;

export default api;
